module.exports = __webpack_public_path__ + "static/media/urn_icon.6b024aa0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/configurator/urn_icon.png
// module id = 561
// module chunks = 0